import { render, staticRenderFns } from "./WebhookSettings.vue?vue&type=template&id=4a40da6f&"
import script from "./WebhookSettings.vue?vue&type=script&lang=js&"
export * from "./WebhookSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports